import './App.css'
import { Suspense, lazy, useEffect } from 'react'
import { LiveSupportLoader } from './components/LiveSupportLoader'
import { OpeningAnimation } from './components/OpeningAnimation'
import { getCafePage } from './data/cafePages'
import { getLanguageFromPath } from './data/languages'
import { SiteLayout } from './layouts/SiteLayout'
// Loaded eagerly (not code-split) — it's the primary landing route, and
// deferring it behind a lazy chunk delayed discovery of the hero <img> (the
// LCP element) and caused a large layout shift when its content popped in
// after the chunk finished loading (Suspense fallback={null} renders the
// footer immediately, then everything above it inserts once HomePage loads).
import { HomePage } from './pages/HomePage'

const AdminRouter = lazy(() => import('./pages/AdminRouter').then((module) => ({ default: module.AdminRouter })))
const CafePage = lazy(() => import('./pages/CafePage').then((module) => ({ default: module.CafePage })))
const QrPage = lazy(() => import('./pages/QrPage').then((module) => ({ default: module.QrPage })))

function App() {
  const pathname = window.location.pathname
  const language = getLanguageFromPath(pathname)
  const cafePage = getCafePage(pathname)
  const isAdmin = pathname.startsWith('/admin')
  const isQr = pathname.includes('/qr')
  // Accept both the site's usual /tr/-prefixed form and the bare root path —
  // guests have been sharing/bookmarking this page without the prefix.
  const isHome =
    pathname === '/' ||
    pathname === `/${language}` ||
    pathname === `/${language}/`

  useEffect(() => {
    document.documentElement.lang = language
  }, [language])

  if (isAdmin) {
    return (
      <Suspense fallback={null}>
        <AdminRouter />
      </Suspense>
    )
  }

  if (isHome) {
    return (
      <SiteLayout language={language}>
        <OpeningAnimation />
        <HomePage language={language} />
        <LiveSupportLoader />
      </SiteLayout>
    )
  }

  return (
    <SiteLayout language={language}>
      <OpeningAnimation />
      <Suspense fallback={null}>
        {isQr ? (
          <QrPage language={language} />
        ) : (
          <CafePage language={language} page={cafePage} />
        )}
      </Suspense>
      <LiveSupportLoader />
    </SiteLayout>
  )
}

export default App
